import React from 'react';
import cn from 'classnames/bind';
import { Button } from '@consta/uikit/Button';
import { IconAdd } from '@consta/uikit/IconAdd';
import { IconSearch } from '@consta/uikit/IconSearch';
import { IconFunnel } from '@consta/uikit/IconFunnel';

// Styles
import styles from './styles.styl';
import { TextField } from '@consta/uikit/TextField';
import { IconComponent } from '@consta/uikit/__internal__/src/icons/Icon/Icon';
import { DirectoryInfoEnum } from 'src/utils/enum';

const cx = cn.bind(styles);

export interface IFilterResult {
  value: any;
  accessor: string;
  label: string;
  type?: string;
  from?: string;
  until?: string;
}

export interface DirectoryInfoProps {
  handleSearch?: (value: string) => void;
  handleClick?: () => void;
  handleClickFilter?: () => void;
  iconButton?: IconComponent;
  iconField?: IconComponent;
  iconFiltr?: IconComponent | DirectoryInfoEnum;
  labelButton?: string;
  plcSeach?: string;
  viewButton?: 'primary' | 'ghost' | 'secondary' | 'clear';
  isActiveFilter?: null | IFilterResult[] | string[][];
  searchValue?: string;
  className?: string;
  hasFilter?: boolean;
  sizeSearch?: 's' | 'xs' | 'm' | 'l';
}

export const DirectoryInfo: React.FC<DirectoryInfoProps> = ({
  handleSearch = () => {},
  handleClick = () => {},
  handleClickFilter = () => {},
  iconButton = IconAdd,
  iconField = IconSearch,
  iconFiltr = IconFunnel,
  labelButton = '',
  plcSeach = 'Поиск по ФИО',
  viewButton = 'primary',
  isActiveFilter,
  searchValue,
  className,
  hasFilter,
  sizeSearch = 's',
}) => {
  return (
    <div className={cx('DirectoryInfo', className)}>
      <div className={cx('DirectoryInfo__row')}>
        <div className={cx('DirectoryInfo__name')}>
          <TextField
            id="search"
            onChange={({ value }) => handleSearch(value)}
            value={searchValue}
            leftSide={iconField}
            className={cx('DirectoryInfo__fieldSearch')}
            size={sizeSearch}
            placeholder={plcSeach}
          />
          {iconFiltr !== DirectoryInfoEnum.iconFieldNone && (
            <Button
              onClick={() => handleClickFilter()}
              className={cx('DirectoryInfo__filtr', {
                DirectoryInfo__filtr_active:
                  (!!isActiveFilter && isActiveFilter?.length !== 0) ||
                  hasFilter,
              })}
              size="s"
              onlyIcon
              iconLeft={iconFiltr}
              view="clear"
              iconSize="s"
            />
          )}
        </div>
        {labelButton && (
          <Button
            onClick={() => handleClick()}
            label={labelButton}
            size="s"
            iconLeft={iconButton}
            iconSize="s"
            view={viewButton}
          />
        )}
      </div>
    </div>
  );
};

export default DirectoryInfo;
